"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UsageTracker = exports._trackers = exports._trackerSendImmediate = exports._tracker = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _enviro = _interopRequireDefault(require("enviro"));

var _usageTracker = require("usage-tracker");

var _events = _interopRequireDefault(require("customer-data-tracking/events.yaml"));

var _namespaces = require("./constants/namespaces");

var _usageTrackerContainer = require("usage-tracker-container");

var _CRM, _SETTINGS, _CALLING, _COMMUNICATOR, _LISTS, _QUOTES, _PRODUCTS, _LINEITEMS, _REPORTING, _trackers2;

var TRACKER = 'tracker';
var SEND_IMMEDIATE = 'trackerSendImmediate';

var _tracker = (0, _usageTracker.createTracker)({
  events: _events.default,
  properties: {
    namespace: _namespaces.CRM
  },
  onError: function onError(err) {
    console.error(err);
  },
  lastKnownEventProperties: ['screen', 'subscreen'],
  debug: function debug() {
    return _enviro.default.debug('customer-data-tracker');
  }
});

exports._tracker = _tracker;

var _trackerSendImmediate = _tracker.clone({
  isBeforeUnload: true
});

exports._trackerSendImmediate = _trackerSendImmediate;

var _trackers = (_trackers2 = {}, (0, _defineProperty2.default)(_trackers2, _namespaces.CRM, (_CRM = {}, (0, _defineProperty2.default)(_CRM, TRACKER, _tracker), (0, _defineProperty2.default)(_CRM, SEND_IMMEDIATE, _trackerSendImmediate), _CRM)), (0, _defineProperty2.default)(_trackers2, _namespaces.SETTINGS, (_SETTINGS = {}, (0, _defineProperty2.default)(_SETTINGS, TRACKER, _tracker.clone({
  properties: {
    namespace: _namespaces.SETTINGS
  }
})), (0, _defineProperty2.default)(_SETTINGS, SEND_IMMEDIATE, _trackerSendImmediate.clone({
  properties: {
    namespace: _namespaces.SETTINGS
  }
})), _SETTINGS)), (0, _defineProperty2.default)(_trackers2, _namespaces.CALLING, (_CALLING = {}, (0, _defineProperty2.default)(_CALLING, TRACKER, _tracker.clone({
  properties: {
    namespace: _namespaces.CALLING
  }
})), (0, _defineProperty2.default)(_CALLING, SEND_IMMEDIATE, _trackerSendImmediate.clone({
  properties: {
    namespace: _namespaces.CALLING
  }
})), _CALLING)), (0, _defineProperty2.default)(_trackers2, _namespaces.COMMUNICATOR, (_COMMUNICATOR = {}, (0, _defineProperty2.default)(_COMMUNICATOR, TRACKER, _tracker.clone({
  properties: {
    namespace: _namespaces.COMMUNICATOR
  }
})), (0, _defineProperty2.default)(_COMMUNICATOR, SEND_IMMEDIATE, _trackerSendImmediate.clone({
  properties: {
    namespace: _namespaces.COMMUNICATOR
  }
})), _COMMUNICATOR)), (0, _defineProperty2.default)(_trackers2, _namespaces.LISTS, (_LISTS = {}, (0, _defineProperty2.default)(_LISTS, TRACKER, _tracker.clone({
  properties: {
    namespace: _namespaces.LISTS
  }
})), (0, _defineProperty2.default)(_LISTS, SEND_IMMEDIATE, _trackerSendImmediate.clone({
  properties: {
    namespace: _namespaces.LISTS
  }
})), _LISTS)), (0, _defineProperty2.default)(_trackers2, _namespaces.QUOTES, (_QUOTES = {}, (0, _defineProperty2.default)(_QUOTES, TRACKER, _tracker.clone({
  properties: {
    namespace: _namespaces.QUOTES
  }
})), (0, _defineProperty2.default)(_QUOTES, SEND_IMMEDIATE, _trackerSendImmediate.clone({
  properties: {
    namespace: _namespaces.QUOTES
  }
})), _QUOTES)), (0, _defineProperty2.default)(_trackers2, _namespaces.PRODUCTS, (_PRODUCTS = {}, (0, _defineProperty2.default)(_PRODUCTS, TRACKER, _tracker.clone({
  properties: {
    namespace: _namespaces.PRODUCTS
  }
})), (0, _defineProperty2.default)(_PRODUCTS, SEND_IMMEDIATE, _trackerSendImmediate.clone({
  properties: {
    namespace: _namespaces.PRODUCTS
  }
})), _PRODUCTS)), (0, _defineProperty2.default)(_trackers2, _namespaces.LINEITEMS, (_LINEITEMS = {}, (0, _defineProperty2.default)(_LINEITEMS, TRACKER, _tracker.clone({
  properties: {
    namespace: _namespaces.LINEITEMS
  }
})), (0, _defineProperty2.default)(_LINEITEMS, SEND_IMMEDIATE, _trackerSendImmediate.clone({
  properties: {
    namespace: _namespaces.LINEITEMS
  }
})), _LINEITEMS)), (0, _defineProperty2.default)(_trackers2, _namespaces.REPORTING, (_REPORTING = {}, (0, _defineProperty2.default)(_REPORTING, TRACKER, _tracker.clone({
  properties: {
    namespace: _namespaces.REPORTING
  }
})), (0, _defineProperty2.default)(_REPORTING, SEND_IMMEDIATE, _trackerSendImmediate.clone({
  properties: {
    namespace: _namespaces.REPORTING
  }
})), _REPORTING)), _trackers2);

exports._trackers = _trackers;

var UsageTracker =
/*#__PURE__*/
function () {
  function UsageTracker() {
    (0, _classCallCheck2.default)(this, UsageTracker);
  }

  (0, _createClass2.default)(UsageTracker, null, [{
    key: "init",
    value: function init(properties) {
      (0, _usageTrackerContainer.setPrimaryTracker)(_tracker);
      Object.keys(_trackers).forEach(function (namespace) {
        _trackers[namespace][TRACKER].setProperties(properties);

        _trackers[namespace][SEND_IMMEDIATE].setProperties(properties);
      });
    }
  }, {
    key: "track",
    value: function track(evt, evtData) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var _options$sendImmediat = options.sendImmediate,
          sendImmediate = _options$sendImmediat === void 0 ? false : _options$sendImmediat,
          _options$namespace = options.namespace,
          namespace = _options$namespace === void 0 ? _namespaces.CRM : _options$namespace;
      var tracker = _trackers[namespace][sendImmediate ? SEND_IMMEDIATE : TRACKER];
      tracker.track(evt, evtData);
    }
  }]);
  return UsageTracker;
}();

exports.UsageTracker = UsageTracker;